export const JOURNEY_WIZARD_QUERY_KEY = 'journey';
export const JOURNEY_WIZARD_ACTIVE_VALUE = '1';

export function isJourneyWizardActive(searchParams: Pick<URLSearchParams, 'get'>): boolean {
  return searchParams.get(JOURNEY_WIZARD_QUERY_KEY) === JOURNEY_WIZARD_ACTIVE_VALUE;
}

export function withJourneyWizardActive(searchParams: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(searchParams);
  next.set(JOURNEY_WIZARD_QUERY_KEY, JOURNEY_WIZARD_ACTIVE_VALUE);
  return next;
}

export function withoutJourneyWizard(searchParams: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(searchParams);
  next.delete(JOURNEY_WIZARD_QUERY_KEY);
  return next;
}
